import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ModalityOrbit } from './ModalityOrbit';
import { orbitNodes } from '../../data/modalities';
const fade = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: index * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-93" data-mp="3783j6obg4b07">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-gradient-to-b from-slate-50 to-white" data-id="element-94" data-mp="3c3slv0iri80q" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:py-24" data-id="element-95" data-mp="3h4yfr1o5s1bu">
        <div className="max-w-xl" data-id="element-96" data-mp="1mqfbounyxprp">
          <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal lg:text-[13px] xl:text-[14px]" data-id="element-97" data-mp="1mrgy1vafpyoq">
            Therapeutic Modalities, Matched to Your Practice
          </motion.p>
          <motion.h1 variants={fade} initial="hidden" animate="show" custom={1} className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-[3.75rem] xl:text-[4rem]" data-id="element-98" data-mp="1y60x16fgicek">
            More Than Equipment. The Right Technology, Implemented the Right
            Way.
          </motion.h1>
          <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="mt-6 text-[17px] leading-relaxed text-charcoal/75 lg:text-[18px] xl:text-[19px] xl:leading-[1.65]" data-id="element-99" data-mp="2gwijwudlyds0">
            JAG Medical Solutions helps doctors cut through modality hype,
            compare proven technologies, and choose equipment that fits their
            patients, team, and growth goals.
          </motion.p>
          <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-100" data-mp="3jouwgsgnpmsl">
            <a href="tel:+19414416131" className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-101" data-mp="39uvvvxw8eb2r">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-102" data-mp="2r333a4l2qrvk" />
              Call (941) 441-6131
            </a>
            <a href="#products" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3.5 text-[15px] font-semibold text-navy transition-colors hover:border-teal hover:text-teal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-103" data-mp="2w0lc7uz3d73k">
              Explore Product Categories
              <ArrowRightIcon className="h-[18px] w-[18px]" data-id="element-104" data-mp="1yh4yvz82h70i" />
            </a>
          </motion.div>
          <motion.p variants={fade} initial="hidden" animate="show" custom={4} className="mt-4 text-sm font-medium text-charcoal/60" data-id="element-105" data-mp="2cge9mjdi78x3">
            Talk with JAG Medical Solutions about the right fit for your
            practice.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="hidden justify-center lg:flex" data-id="element-106" data-mp="2hcv3zvbaqjim">
          <ModalityOrbit data-id="element-107" data-mp="306qjw0w81hqu" />
        </motion.div>

        <div className="grid grid-cols-2 gap-3 lg:hidden" data-id="element-108" data-mp="xirzdubeseao">
          {orbitNodes.map(node => <div key={node.id} className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-109" data-mp="12hbmhy1qnw4m">
              <div className="flex items-start justify-between gap-2" data-id="element-110" data-mp="178tpernbo6s8">
                <p className="font-display text-sm font-bold leading-tight text-navy" data-id="element-111" data-mp="1c7o8lup7bxcv">
                  {node.name}
                </p>
                {node.status && <span className="shrink-0 rounded-full bg-teal/10 px-2 py-1 text-[9px] font-semibold uppercase tracking-wide text-teal" data-id="element-112" data-mp="jihagwtnt9s5">
                    Coming soon
                  </span>}
              </div>
              <p className="mt-1.5 text-xs leading-snug text-charcoal/55" data-id="element-113" data-mp="thycn49pd5jd">
                {node.detail}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}